import { ReservationTimeState, ServiceOrderState } from '@mews-commander/legacy-data-structures';
import { ReservationStateTag } from '../../../../components/reservation/ReservationStateTag';

export const ReservationStateName = ({ reservationTimeState, serviceOrderState, options }: $TSFixMe) => {
    const timeState = ReservationTimeState.getByName(reservationTimeState);
    const state = ServiceOrderState.getByName(serviceOrderState);
    return <ReservationStateTag timeState={timeState} state={state} options={options} />;
};
